import React from 'react';
import { Table, Tooltip } from 'antd';

const CommonTable = ({
    data = [],
    columns = [],
    loading = false,
    pagination = {},
    onChange = () => {},
    rowKey = '_id',
    scroll = { x: 1200, y: '60vh' },
    expandable = null,
    bordered = true,
    ...other
}) => {
    const enhancedColumns = [
        {
            title: 'Sr. No',
            key: 'sr_no',
            width: 80,
            align: 'center',
            fixed: 'left',
            render: (_text, _record, index) => {
                const pageNo = pagination?.pageNo || 0;
                const limit = pagination?.limit || 15;
                return pageNo * limit + index + 1;
            },
        },
        ...columns.map((col) => {
            const originalRender = col.render;

            return {
                ...col,
                ellipsis: col.ellipsis !== false,
                width: col.width || 200,
                render: (text, record, index) => {
                    const renderedContent = originalRender
                        ? originalRender(text, record, index)
                        : text;

                    const shouldShowTooltip =
                        typeof renderedContent === 'string' ||
                        React.isValidElement(renderedContent);

                    return shouldShowTooltip ? (
                        <Tooltip
                            title={
                                typeof renderedContent === 'string'
                                    ? renderedContent
                                    : undefined
                            }
                        >
                            <div className="cell-content">{renderedContent}</div>
                        </Tooltip>
                    ) : (
                        renderedContent
                    );
                },
            };
        }),
    ];

    return (
        <Table
            className="common-table"
            loading={loading}
            dataSource={data}
            columns={enhancedColumns}
            pagination={{
                current: pagination?.pageNo + 1,
                pageSize: pagination?.limit || 15,
                total: pagination?.count,
                pageSizeOptions: ['15', '30', '50', '100', '200'],
                showSizeChanger: true,
                showQuickJumper: true,
                showTotal: (total) => `Total ${total} records`,
            }}
            onChange={onChange}
            rowKey={rowKey}
            scroll={scroll}
            bordered={bordered}
            sticky
            expandable={expandable}
            {...other}
        />
    );
};

export default CommonTable;
